document.addEventListener("DOMContentLoaded", function () {

  const heroSlider = document.querySelector(".hero-slider-swiper");

  if (!heroSlider) return;

  new Swiper(heroSlider, {

    loop: true,

    speed: 700,

    effect: "fade",

    fadeEffect: {
      crossFade: true
    },

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },

    keyboard: {
      enabled: true
    },

    grabCursor: true

  });

});